import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=46aed2e6&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=46aed2e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aed2e6",
  null
  
)

export default component.exports